<ngx-spinner></ngx-spinner>
<app-header [musicplayer]="model.type"></app-header>
<div class="wrapper">
  <div class="container">
    <div class="row justify-content-center mr-0">
      <div
        class="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-12"
        *ngIf="musicDetail"
      >
        <div class="partner-profile-detail player-detail">
          <div class="partner-profile">
            <div class="ratio-slider ratio-1-1">
              <img
                *ngIf="type === 'musicDetail'"
                src="{{ musicDetail?.thumbnails | thumbnails: 'square' }}"
              />
              <img
                *ngIf="type === 'playList'"
                src="{{
                  songlist.length > 0
                    ? playlistThumbnail
                    : appConstant.playListImg
                }}"
              />
            </div>
          </div>
          <div class="user-detail">
            <h3 *ngIf="type === 'playList'" class="mb-2">
              {{ musicDetail.name }}
            </h3>
            <h3 *ngIf="type === 'musicDetail'" class="mb-2">
              {{ musicDetail.title }}
            </h3>
            <p class="text-secondary">
              <span>{{ songlist.length }} </span>
              <span *ngIf="songlist.length > 1">Tracks</span>
              <span *ngIf="songlist.length === 1">Track</span>
              <span *ngIf="musicDetail.published_year">&nbsp; | &nbsp;</span>
              <span>{{ musicDetail.published_year }} </span>
              <span *ngIf="type == 'playList' && songlist.length == 0"
                >Song</span
              >
            </p>
            <p class="music-description">{{ musicDetail.description }}</p>
            <button
              *ngIf="!service.audioStatus"
              type="button"
              class="btn btn-theme play-btn mt-3"
              (click)="play('play_all', '')"
            >
              <span class="mdi mdi-play mr-2"></span>
              {{ "MUSIC_INFO.PLAY" | translate }}
            </button>
            <button
              *ngIf="service.audioStatus && songlist.length > 0"
              type="button"
              class="btn btn-theme play-btn mt-3"
              (click)="play('play_all', '')"
            >
              <span class="mdi mdi-pause mr-2"></span>
              {{ "MUSIC_INFO.PAUSE" | translate }}
            </button>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-12 mob-col"
        *ngIf="songlist.length > 0"
      >
        <!-- <h3 class="text-secondary">Top Songs</h3> -->
        <ul class="music-list music-list-head mb-0">
          <li class="py-0">
            <div class="s_cnt py-0">
              <a href="javascript:void(0)">S.No</a>
            </div>
            <div class="s_title py-0">
              <a href="javascript:void(0)">{{
                "MUSIC_INFO.TITLE" | translate
              }}</a>
            </div>
            <div class="s_artist py-0">
              <a href="javascript:void(0)">{{
                "MUSIC_INFO.ARTISTS" | translate
              }}</a>
            </div>
            <div class="s_duration py-0 w-100 text-right">
              <a href="javascript:void(0)"> Time </a>
            </div>
          </li>
        </ul>
        <hr class="mb-0 border-0 mt-1" />
        <ul class="music-list">
          <li
            *ngFor="let song of musicDetail.songs; let i = index"
            (click)="play(song, i)"
            [ngClass]="{
              active: selectedIndex == i && service.audioStatus,
              pause: selectedIndex == i && !service.audioStatus
            }"
          >
            <div class="s-no">{{ i + 1 }}</div>

            <div class="image-sect">
              <div class="player-img">
                <img [src]="getImage(i)" />
                <div class="player-svg-icon">
                  <img [src]="appConstant.musicActiveIcon" />
                </div>
              </div>
              <div class="music-detail">
                <a class="mb-0 text-secondary song-name"> {{ song.name }} </a>
                <div
                  class="singer-name"
                  *ngIf="song?.cast_and_crew?.length > 0"
                >
                  <a *ngFor="let cast of song.cast_and_crew; let i = index">
                    <span>{{ cast.name | titlecase }}</span>
                    <span *ngIf="song.cast_and_crew.length !== i + 1"
                      >,&nbsp;</span
                    >
                  </a>
                </div>
              </div>
            </div>
            <div
              class="text-center favrate-icon"
              style="min-width: 60px"
              (click)="$event.stopPropagation()"
            >
              <div *ngIf="!isLogin">
                <a
                  [matMenuTriggerFor]="Add_to_favorite"
                  class="like-icon text-white"
                >
                  <span
                    *ngIf="!song.is_favorite.id"
                    class="mdi mdi-heart-outline"
                  ></span>
                  <span
                    *ngIf="song.is_favorite.id"
                    class="mdi mdi-heart fill-back"
                  ></span>
                </a>
                <mat-menu #Add_to_favorite="matMenu" class="please_login">
                  <div (click)="$event.stopPropagation()">
                    <p>{{ "MUSIC_INFO.SIGNIN_MESSAGE" | translate }}</p>
                    <hr />
                    <a
                      href="javascript:void(0)"
                      (click)="singIn('Add_to_favorite', i)"
                    >
                      {{ "VIDEO_DETAIL.SIGN_IN" | translate }}
                    </a>
                  </div>
                </mat-menu>
              </div>
              <div *ngIf="isLogin" class="mr-2 ml-2 d-flex align-items-center">
                <button
                  class="btn remove-song mr-2"
                  *ngIf="type === 'playList'"
                  (click)="deleteSong(song, i)"
                >
                  <span class="mdi mdi-close"></span>
                </button>
                <a class="like-icon text-white" (click)="favoriteSong(song, i)">
                  <span
                    *ngIf="!song.is_favorite.id"
                    class="mdi mdi-heart-outline"
                  ></span>
                  <span
                    *ngIf="song.is_favorite.id"
                    class="mdi mdi-heart fill-back"
                  ></span>
                </a>
              </div>
            </div>
            <div class="song-duration">
              <span> {{ song.duration | music_duration }} </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="audio-player" *ngIf="playerStatus && songlist.length > 0">
    <div class="c-player__current" [ngClass]="{ active: isActive }">
      <figure
        class="d-flex align-items-center justify-content-between w-100 mb-0"
      >
        <div class="o-flag__img">
          <a
            class="ratio-slider ratio-1-1"
            screen_name="player_screen"
            event_item="[object Object]"
            title="Agar Tum Saath Ho"
            href="javascript:void(0)"
          >
            <img [src]="getImage(selectedIndex)" alt="test" />
          </a>
        </div>
        <figcaption class="o-flag__body">
          <h5 class="">
            <a class="u-color-js-gray" href="javascript:void(0)"
              >{{ songSrc?.name }}
            </a>
          </h5>
          <p class="mb-0">
            <a *ngFor="let cast of songSrc?.cast_and_crew; let i = index">
              <span>{{ cast.name | titlecase }}</span>
              <span *ngIf="songSrc.cast_and_crew.length !== i + 1"
                >,&nbsp;</span
              >
            </a>
          </p>
        </figcaption>
        <div class="d-flex align-items-center">
          <div *ngIf="!isLogin" class="favirate-icon">
            <a
              [matMenuTriggerFor]="Add_to_favorites"
              class="like-icon text-white"
            >
              <span
                *ngIf="!songSrc?.is_favorite.id"
                class="mdi mdi-heart-outline"
              ></span>
              <span
                *ngIf="songSrc?.is_favorite.id"
                class="mdi mdi-heart fill-back"
              ></span>
            </a>
            <mat-menu #Add_to_favorites="matMenu" class="please_login">
              <div (click)="$event.stopPropagation()">
                <p>{{ "MUSIC_INFO.SIGNIN_MESSAGE" | translate }}</p>
                <hr />
                <a
                  href="javascript:void(0)"
                  (click)="singIn('Add_to_favorites', selectedIndex)"
                >
                  {{ "VIDEO_DETAIL.SIGN_IN" | translate }}
                </a>
              </div>
            </mat-menu>
          </div>
          <div *ngIf="isLogin" class="favirate-icon">
            <a
              class="like-icon text-white text-center"
              (click)="favoriteSong(songSrc, selectedIndex)"
            >
              <span
                *ngIf="!songSrc.is_favorite.id"
                class="mdi mdi-heart-outline"
              ></span>
              <span
                *ngIf="songSrc.is_favorite.id"
                class="mdi mdi-heart fill-back"
              ></span>
            </a>
          </div>

          <a class="like-icon text-white text-center" (click)="classActive()">
            <span
              class="mdi"
              [ngClass]="{
                'mdi-dots-horizontal': !isActive,
                'mdi-chevron-down': isActive
              }"
            ></span>
          </a>
        </div>
      </figure>
      <div class="player-popup">
        <div *ngIf="!isLogin">
          <a
            [matMenuTriggerFor]="Add_to_playlist"
            href="javascript:void(0)"
            class="addtoplaylist"
          >
            <span class="icon-watch-list"></span>
            {{ "MUSIC_INFO.ADD_TO_PLAYLIST" | translate }}
          </a>
          <mat-menu #Add_to_playlist="matMenu" class="please_login">
            <div (click)="$event.stopPropagation()">
              <p>{{ "MUSIC_INFO.SIGNIN_MESSAGE" | translate }}</p>
              <hr />
              <a
                href="javascript:void(0)"
                (click)="singIn('Add_to_playlist', selectedIndex)"
              >
                {{ "VIDEO_DETAIL.SIGN_IN" | translate }}
              </a>
            </div>
          </mat-menu>
        </div>
        <div *ngIf="isLogin">
          <a
            href="javascript:void(0)"
            class="addtoplaylist"
            (click)="addToPlayList(songSrc)"
          >
            <span class="icon-watch-list"></span>
            {{ "MUSIC_INFO.ADD_TO_PLAYLIST" | translate }}
          </a>
        </div>

        <a href="javascript:void(0)" class="share" (click)="openShareContent()">
          <span class="mdi mdi-share-variant-outline"></span>
          {{ "MUSIC_INFO.SHARE" | translate }}
        </a>
      </div>
    </div>
    <audio-vjs-player
      *ngIf="output_url"
      (buttonStatus)="songPlay($event)"
      (playerStatus)="songStatus($event)"
      [playinStatus]="service.audioStatus"
      [options]="{
        autoplay: true,
        bigPlayButton: false,
        loadingSpinner: true,
        errorDisplay: false,
        sources: [
          {
            src: output_url,
            type: typeContent
          }
        ],
        controlBar: {
          pictureInPictureToggle: false,
          fullscreenToggle: false
        }
      }"
    >
    </audio-vjs-player>
  </div>
  <section
    class="pt-3 pb-5 pr-2"
    *ngIf="type == 'playList' && songlist.length == 0"
  >
    <div class="container">
      <div class="d-flex align-items-center justify-content-center">
        <div class="browse-playlist">
          <h3>It's pretty quiet in here.</h3>
          <p>Let's find some tunes for your playlist!</p>
          <button class="btn btn-theme" routerLink="/music">
            Browse New Releases
          </button>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- <app-footer></app-footer> -->
